import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';
import {bool, func, number, oneOfType, string} from 'prop-types';

import usePayment from '../../../../hooks/providers/usePayment';
import {calculateProductPrice, getHumanReadablePrice} from '../../../../utils/payment';
import Button from '../../../form/buttons/Button/Button';

const DottedLine = muiStyled(Box)(() => ({
  margin: '0 4px 6px 6px',
  borderBottom: '1px dotted grey'
}));

const CartSinglePriceLine = ({label, price, isTotal, testId}) => {
  const fontWeight = isTotal ? 'bold' : 'normal';
  return (
    <Grid container alignItems="flex-end" mb={1}>
      <Typography fontWeight={fontWeight} fontSize={16}>
        {label} :{' '}
      </Typography>
      <Grid item xs>
        <DottedLine />
      </Grid>

      <Typography data-testid={testId} fontWeight={fontWeight} fontSize={16}>
        {price} €
      </Typography>
    </Grid>
  );
};

CartSinglePriceLine.propTypes = {
  label: string.isRequired,
  testId: string.isRequired,
  price: oneOfType([number, string]).isRequired,
  isTotal: bool
};

const CartPrices = ({isSubmitting, onSubmit}) => {
  const {cart, products, subscription, hasMembership} = usePayment();

  const total = cart.reduce((acc, item) => {
    const product = products.find(p => p.id === item.id);
    const {quantity = 0} = item;
    if (product) {
      const productPrice = calculateProductPrice(product, quantity);
      return acc + productPrice;
    }

    return acc;
  }, 0);

  const priceWithoutTaxes = getHumanReadablePrice(total);
  const taxes = total * 0.2;

  const priceWithTaxes = getHumanReadablePrice(total + taxes);

  const userHasUpdatedProductQuantities = cart.some(item => {
    const product = subscription?.products.find(p => p.product_id === item.id);
    return item.quantity !== (product?.quantity || 0);
  });

  const cartIsEmpty = !subscription?.subscription_id && (cart.length === 0 || cart.every(i => (i.quantity || 0) === 0));
  const isSubmitButtonDisabled = isSubmitting || !userHasUpdatedProductQuantities || cartIsEmpty;
  const buttonText = hasMembership ? 'Mettre à jour' : "Je m'abonne";

  return (
    <div>
      <CartSinglePriceLine testId="cart-subtotal" label="Sous-total" price={priceWithoutTaxes} />

      <CartSinglePriceLine testId="cart-taxes" label="TVA (20%)" price={getHumanReadablePrice(taxes)} />

      <CartSinglePriceLine testId="cart-total" isTotal label="Total par mois" price={priceWithTaxes} />

      {isSubmitting ? null : (
        <Button disabled={isSubmitButtonDisabled} sx={{mt: 2}} fullWidth variant="contained" color="secondary" onClick={onSubmit}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};

CartPrices.propTypes = {
  isSubmitting: bool.isRequired,
  onSubmit: func.isRequired
};

export default CartPrices;
